import { css } from "@emotion/react"
import { BREAKPOINTS } from "source/shared/hooks/useWindowDimensions"

type PaneGroupProps = {
  children: React.ReactNode
  direction?: "row" | "column"
}

export function PaneGroup({ children, direction = "row" }: PaneGroupProps) {
  const BORDER_COLOR = "var(--color-tint5)"
  return (
    <div
      className="d-f jc-sb"
      css={css`
        flex-direction: ${direction};

        @media (min-width: ${BREAKPOINTS.MD}px) {
          border: 1px solid ${BORDER_COLOR};
          border-radius: 0.5rem;

          > * {
            padding: 1.5rem;
            border: 0 solid ${BORDER_COLOR};
          }

          // add border on the dividing axis
          > * + * {
            ${direction === "row"
              ? "border-left-width: 1px;"
              : "border-top-width: 1px;"}
          }
        }
      `}
    >
      {children}
    </div>
  )
}
